module.exports = __webpack_public_path__ + "img/mode2.1e7587c6.png";